const delay = (time: number) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

const waitForElement = async (className: string, index: number, maxWaitTime = 2000): Promise<any> => {
  // ใช้สำหรับรอ element ready
  const start = Date.now();
  while (Date.now() - start < maxWaitTime) {
    const item = document.getElementsByClassName(className)[index];
    if (item) {
      return item;
    } else {
      // wait a little and try again
      await delay(100);
    }
  }
  return null;
};

export { waitForElement };
